// ── Crazy Cards: the carnival table. Purple felt, neon piping and the
//    mega wheel burned into the cloth. ──

import Table3D from './Table3D';

const WheelInlay = () => {
  const segs = 16;
  const colors = ['#ef4444', '#22c55e', '#fbbf24', '#8b5cf6'];
  return (
    <svg viewBox="0 0 400 260" preserveAspectRatio="none" style={{ width: '100%', height: '100%', opacity: 0.9 }}>
      {/* fascia alta: insegna */}
      <g opacity="0.8">
        <path d="M18 20 Q120 6 200 18 Q280 6 382 20" fill="none" stroke="#c4b5fd" strokeWidth="1.2" opacity="0.5" />
        {Array.from({ length: 13 }, (_, i) => (
          <circle key={i} cx={22 + i * 30} cy={i % 2 ? 14 : 19} r="3" fill={colors[i % colors.length]} opacity="0.75" />
        ))}
      </g>

      {/* centro: la mega ruota */}
      <g transform="translate(200 130)" opacity="0.32">
        {Array.from({ length: segs }, (_, i) => {
          const a0 = (i / segs) * Math.PI * 2, a1 = ((i + 1) / segs) * Math.PI * 2;
          const R = 78;
          const x0 = Math.cos(a0) * R, y0 = Math.sin(a0) * R;
          const x1 = Math.cos(a1) * R, y1 = Math.sin(a1) * R;
          return (
            <path key={i} d={`M0 0 L${x0} ${y0} A${R} ${R} 0 0 1 ${x1} ${y1} Z`}
              fill={colors[i % colors.length]} opacity="0.5" stroke="#1a0d33" strokeWidth="0.8" />
          );
        })}
        <circle r="78" fill="none" stroke="#c4b5fd" strokeWidth="1.6" />
        <circle r="14" fill="#1a0d33" stroke="#c4b5fd" strokeWidth="1.2" />
      </g>

      {/* fascia bassa: la posta */}
      <g opacity="0.85">
        <path d="M18 240 Q120 226 200 238 Q280 226 382 240" fill="none" stroke="#c4b5fd" strokeWidth="1.2" opacity="0.5" />
        {[60, 140, 260, 340].map((x, i) => (
          <circle key={i} cx={x} cy={i % 2 ? 234 : 240} r="3.4" fill={colors[(i + 1) % colors.length]} opacity="0.8" />
        ))}
        <text x="200" y="256" textAnchor="middle" fontSize="9" letterSpacing="5"
          fill="#d8b4fe" fontFamily="'Cinzel',serif" opacity="0.8">TIENI LA CASSA</text>
      </g>
    </svg>
  );
};

const CcTable = ({ children, mobile = false, active = false }) => (
  <Table3D
    mobile={mobile}
    active={active}
    grain={86}
    surface={{ top: '#3b1d6e', mid: '#1f0d3f', low: '#2e1656', deep: '#120722' }}
    trim={{
      rim: 'rgba(168,85,247,0.85)', rivet: '#d8b4fe', ink: '#1b0b3a',
      accent: '#c084fc', glow: 'rgba(168,85,247,0.3)',
    }}
    inlay={<WheelInlay />}
  >
    {children}
  </Table3D>
);

export default CcTable;
